var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-box" }, [
    _c("div", [
      _c("span", { staticClass: "test" }, [_vm._v("新增凤香荟终端（家）：")]),
      _c("span", { staticClass: "money" }, [
        _vm._v(_vm._s(_vm.totalInfo.addTotal || 0)),
      ]),
    ]),
    _c("div", [
      _c("span", { staticClass: "test" }, [_vm._v("参与凤香荟终端（家）：")]),
      _c("span", { staticClass: "money" }, [
        _vm._v(_vm._s(_vm.totalInfo.joinTotal || 0)),
      ]),
    ]),
    _c("div", [
      _c("span", { staticClass: "test" }, [_vm._v("未参与凤香荟终端（家）：")]),
      _c("span", { staticClass: "money" }, [
        _vm._v(_vm._s(_vm.totalInfo.notJoinTotal || 0)),
      ]),
    ]),
    _c("div", [
      _c("span", { staticClass: "test" }, [_vm._v("涉及人员：")]),
      _c("span", { staticClass: "money" }, [
        _vm._v(_vm._s(_vm.totalInfo.joinSupplyTotal || 0)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }